<template>
    <eqt-table @refresh="refresh" @delete="deleteItem" :total="total" :loading="loading" :title="$t('Pages.TravelWarrants.title')" :subtitle="$t('Common.table_subtitle')" :items="items" :headers="headers">
        <template slot="items" slot-scope="{ item }">
            <td>{{ item.id }}</td>
            <td>{{ item.orderer && item.orderer.profile ? item.orderer.profile.name : $t('Common.not_assigned')}}</td>
            <td>{{ item.users && item.users.length > 0 ?  getUserNames(item) : $t('Common.not_assigned')}}</td>
            <td>{{ item.vehicle ? item.vehicle.licence_plates : $t('Common.not_assigned')}}</td>
            <td>{{ getLocaleDateFormat(item.start, true)}}</td>
            <td>{{ getLocaleDateFormat(item.end, true)}}</td>
            <td>{{ item.destination}}</td>
            <td>{{ item.mission}}</td>
            <td><v-icon :color="item.locked ? 'red' : 'success'"  small>{{item.locked ? 'mdi-lock' : 'mdi-lock-open'}}</v-icon></td>
        </template>
        <template slot="action-items" slot-scope="{ item }">
            <v-tooltip top>
                <v-btn slot="activator" class="mx-0" small flat icon color="indigo"  @click="print(item)">
                    <v-icon  small>mdi-download</v-icon>
                </v-btn>
                <span>{{$t('Core.Fields.download')}}</span>
            </v-tooltip>
            <slot name="action-items" :item="item"></slot>
        </template>
    </eqt-table>
</template>

<script>
    import i18n from '@/i18n'
    import EqtTable from '../../components/core/Table'
    import _ from 'lodash'
    export default {
        name: "travel-warrants-table",
        components: {EqtTable},
        props: {
            items: {
              type: Array,
              required: true
            },
            total: {
                type: Number,
                default: 0,
            },
            loading: {
                type: Boolean,
                required: true
            },
            hideActions: {
                type: Boolean,
                default: false
            }
        },
        data: () => ({
            headers: [
                {
                    sortable: true,
                    text: '#',
                    value: 'id'
                },
                {
                    sortable: false,
                    text: i18n.t('Pages.TravelWarrants.model.orderer'),
                    value: 'orderer_id'
                },
                {
                    sortable: false,
                    text: i18n.t('Pages.Users.title'),
                    value: 'users'
                },
                {
                    sortable: false,
                    text: i18n.t('Pages.Vehicles.title_singular'),
                    value: 'vehicle.licence_plates'
                },
                {
                    sortable: true,
                    text: i18n.t('Pages.TravelWarrants.model.start'),
                    value: 'start'
                },
                {
                    sortable: true,
                    text: i18n.t('Pages.TravelWarrants.model.end'),
                    value: 'end'
                },
                {
                    sortable: false,
                    text: i18n.t('Pages.TravelWarrants.model.destination'),
                    value: 'destination'
                },
                {
                    sortable: false,
                    text: i18n.t('Pages.TravelWarrants.model.mission'),
                    value: 'mission'
                },
                {
                    sortable: false,
                    text: '',
                    value: 'locked'
                },
            ],
        }),
        computed:{

        },
        methods: {
            refresh(data){
                this.$emit('refresh', data);
            },
            deleteItem(item){
                this.$emit('delete', item);
            },
            print(item){
                this.repositories.travelWarrant.exportTravelWarrant(item.id);
            },
        },
        watch: {

        }
    }
</script>

<style scoped>

</style>
